import React, { useEffect, useMemo, useState } from 'react'
import { toast } from 'utils/notify'
import { getConfBuildings } from 'store/building'
import MultiAutocomplete from 'components/MultiAutocomplete'
import { FirestoreDatabase } from '../../../../../index'
import {
  Box,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Typography,
  makeStyles,
  Divider,
  Checkbox
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Formik, Form } from 'formik'
import CustomDateTimePicker from 'components/CustomDateTimePicker'
import TextField from '@material-ui/core/TextField'

import ViewHeader from 'components/ViewHeader'
import ProgressButton from 'components/ProgressButton'
import {
  addEvent,
  deleteAllSubEventsOfEvent,
  fetchEventById,
  getCardColors,
  resetEventStore,
  updateEventById,
  updateEventTalks,
  updateSubEvents
} from 'store/event'
import { getConferenceSponsors } from 'store/sponsor'
import { eventFormSchema } from 'schemas/event'
import { Add } from '@material-ui/icons'
import CustomTextField from 'components/Form/CustomTextField'
import CustomBox from 'components/Form/CustomBox'
import moment from 'moment-timezone'
import { getDefaultTimezone } from 'utils/times'
import { colors, getContrastColor } from 'utils/colors'
import { getWarningTextBasedOnEventTypesChange, removeUndefinedItemsFromArrayOfString } from 'utils'
import { AssociatedPollMsg, SpeakerRoles, Collection } from 'constants/index'
import { getModeratorsAndPresenters } from 'store/speaker'
import { alreadyUsedPoll, pollAttachOrDetach } from 'store/polling'
import ConfirmModal from 'components/ConfirmationModal'
import BuildingForm from 'views/admin/building/BuildingForm'
import CustomPopup from 'components/CustomPopup'
import EventCardForm from 'views/admin/eventCards/EventCardForm'
import OrganizationForm from 'views/admin/organizations/OrganizationForm'
import PollAssignment from 'components/PollAssignment/PollAssignment'
import TipTapEditor from 'components/TipTapEditor/TipTapEditor'

import ErrorMessage from 'components/ErrorMessage'
import Autocomplete from '@material-ui/lab/Autocomplete'
import DocumentUpload from 'components/DocumentUpload'
import {
  addEventAttachments,
  deleteEventAttachment,
  getEventAttachments,
  listenToEventAttachments
} from 'utils/eventAttachments'
import { storageRef } from '../../../../../index'
import SpeakerForm from 'views/admin/speakers/SpeakerForm'
import { TagForm } from 'views/admin/conference/components/TagsManagementForm'
import DataLoading from 'components/DataLoading'

const EventForm = () => {
  const classes = useStyles()
  const { eventId } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [isWarningModalOpen, setIsWarningModal] = useState(false)
  const [isSubEventsWarningModalOpen, setIsSubEventsWarningModalOpen] = useState(false)
  const [isAddSubEventsWarningModalOpen, setIsAddSubEventsWarningModalOpen] = useState(false)
  const [isVenueTimeUpdateModalOpen, setIsVenueTimeUpdateModalOpen] = useState(false)
  const [venueTimeChangeDetails, setVenueTimeChangeDetails] = useState({
    venue: false,
    time: false,
    hasSubEvents: false
  })
  const [isPendingUploadsModalOpen, setIsPendingUploadsModalOpen] = useState(false)
  const [pendingFormValues, setPendingFormValues] = useState(null)
  const [attachments, setAttachments] = useState([])
  const [loadingAttachments, setLoadingAttachments] = useState(false)
  const [temporaryAttachments, setTemporaryAttachments] = useState([])
  const [hasPendingUploads, setHasPendingUploads] = useState(false)

  const [confBuildings, setConfBuildings] = useState([])
  const [confSponsors, setConfSponsors] = useState([])
  const [confSpeakers, setConfSpeakers] = useState([])
  const [confModerators, setConfModerators] = useState([])
  const [confCardColors, setConfCardColors] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const { event, inProgress } = useSelector((state) => state.event)
  const [openVenueModal, setOpenVenueModal] = useState(false)
  const [openCardColorModal, setOpenCardColorModal] = useState(false)
  const [openSponsorModal, setOpenSponsorModal] = useState(false)
  const [speakerModalInfo, setSpeakerModalInfo] = useState(null)
  const [tagModalOpen, setTagModalOpen] = useState(false)

  const { user } = useSelector((state) => state.auth)
  const { conference } = useSelector((state) => state.conference)
  const defaultTimezone = useMemo(() => getDefaultTimezone(conference?.timezone), [conference])

  const startDateLS = localStorage.getItem('eventStartDate')
    ? parseInt(localStorage.getItem('eventStartDate'))
    : null
  const endDateLS = localStorage.getItem('eventEndDate')
    ? parseInt(localStorage.getItem('eventEndDate'))
    : null

  const initialValues = {
    title: event?.title ?? '',
    venueId: event?.venueId ?? '',
    hasSubEvents: event?.hasSubEvents ?? false,
    startDate: event?.startDate
      ? moment(event?.startDate).tz(defaultTimezone)
      : startDateLS
      ? moment(startDateLS).tz(defaultTimezone)
      : conference?.startDate
      ? moment(conference?.startDate).tz(defaultTimezone)
      : null,
    endDate: event?.endDate
      ? moment(event?.endDate).tz(defaultTimezone)
      : endDateLS
      ? moment(endDateLS).tz(defaultTimezone)
      : conference?.endDate
      ? moment(conference?.endDate).tz(defaultTimezone)
      : null,
    sponsors: event?.sponsors || [],
    moderators: event?.moderators || [],
    speakers: event?.speakers || [],
    tags: event?.tags || [],
    cardStyle: event?.cardStyle ?? '',
    keynotes: event?.keynotes ?? '',
    havePolls: event?.havePolls === true ? 'yes' : 'no',
    pollIds: event?.pollIds ?? (event?.pollId ? [event.pollId] : []),
    excludeFromAttendance: event?.excludeFromAttendance ?? false
  }

  const goBack = () => history.goBack()

  const fetchBuildings = async () => {
    const buildings = await getConfBuildings(user?.conferenceId)
    setConfBuildings(buildings)
  }

  const fetchCardColors = async () => {
    const cardColors = await getCardColors(user?.conferenceId)
    setConfCardColors(cardColors)
  }

  const fetchModeratorsAndPresenters = async () => {
    const data = await getModeratorsAndPresenters(user?.conferenceId)
    setConfSpeakers(data.presenters)
    setConfModerators(data.moderators)
  }

  const fetchSponsors = async () => {
    const sponsors = await getConferenceSponsors(user?.conferenceId)
    setConfSponsors(sponsors)
  }

  useEffect(() => {
    if (!eventId) dispatch(resetEventStore())
  }, [eventId])

  useEffect(() => {
    const fetch = async () => {
      setIsLoading(true)
      await Promise.all([
        fetchBuildings(),
        fetchCardColors(),
        fetchModeratorsAndPresenters(),
        fetchSponsors()
      ])
      setIsLoading(false)
    }
    fetch()
  }, [])

  useEffect(() => {
    if (eventId) {
      dispatch(fetchEventById(eventId))
    }

    return () => dispatch(resetEventStore())
  }, [dispatch, eventId, user?.conferenceId])

  // Set up listener for attachments when eventId is available
  useEffect(() => {
    let unsubscribe = null

    if (eventId) {
      setLoadingAttachments(true)
      unsubscribe = listenToEventAttachments(eventId, (fetchedAttachments) => {
        setAttachments(fetchedAttachments)
        setLoadingAttachments(false)
      })
    } else {
      setAttachments([])
    }

    return () => {
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [eventId])

  const handleCloseWarningModal = () => {
    setIsWarningModal(false)
  }

  const deleteAllSubEvents = async (eventId) => {
    try {
      setLoading(true)
      const result = await deleteAllSubEventsOfEvent(eventId)
      result && toast.success(`Deleted ${result} sub-event(s)`)
      setLoading(false)
    } catch (error) {
      console.error('Error deleting sub-events:', error)
      toast.error('Could not delete sub-events. Try again.')
      setLoading(false)
      return false
    }
    return true
  }

  // Function to delete all talks/posters associated with an event
  const deleteAllTalksOfEvent = async (eventId) => {
    try {
      setLoading(true)
      // Query for all talks associated with this event
      const talksSnapshot = await FirestoreDatabase.collection(Collection.TALKS)
        .where('eventId', '==', eventId)
        .get()

      if (talksSnapshot.empty) {
        toast.info('No talks/posters found to delete')
        return true // No talks to delete
      }

      // Create a batch to delete all talks at once
      const batch = FirestoreDatabase.batch()
      talksSnapshot.docs.forEach((doc) => {
        const talkRef = FirestoreDatabase.collection(Collection.TALKS).doc(doc.id)
        batch.delete(talkRef)
      })

      // Commit the batch delete
      await batch.commit()

      const talkCount = talksSnapshot.size
      toast.success(`Deleted ${talkCount} talk(s)/poster(s)`)
      setLoading(false)
    } catch (error) {
      console.error('Error deleting talks/posters:', error)
      toast.error('Failed to delete talks/posters')
      setLoading(false)
      return false
    }
    return true
  }

  const handleSubEventsWarningConfirm = async () => {
    // Delete all sub-events and then continue with form submission
    if (eventId && pendingFormValues) {
      setLoading(true)
      try {
        const success = await deleteAllSubEvents(eventId)
        if (success) {
          // Continue with form submission using the same approach as for talks/posters
          await onSubmit(pendingFormValues, { fromConfirmation: true })
          // toast.success('Event updated and all sub-events removed')
        } else {
          toast.error('Could not delete sub-events. Try again.')
        }
      } catch (error) {
        console.error('Error updating event after sub-events deletion:', error)
        toast.error('Could not update event after deleting sub-events.')
      } finally {
        setLoading(false)
      }
    }
    setIsSubEventsWarningModalOpen(false)
  }

  const handleCloseSubEventsWarningModal = () => {
    setIsSubEventsWarningModalOpen(false)
    setPendingFormValues(null)
  }

  const handleVenueTimeUpdateConfirm = async () => {
    if (pendingFormValues) {
      // Continue with form submission with the fromConfirmation flag
      await onSubmit(pendingFormValues, { fromConfirmation: true })
    }
    setIsVenueTimeUpdateModalOpen(false)
  }

  const handleCloseVenueTimeUpdateModal = () => {
    setIsVenueTimeUpdateModalOpen(false)
    setVenueTimeChangeDetails({ venue: false, time: false, hasSubEvents: false })
    setPendingFormValues(null)
  }

  const handlePendingUploadsConfirm = async () => {
    if (pendingFormValues) {
      // Continue with form submission with the fromConfirmation flag
      await onSubmit(pendingFormValues, { fromConfirmation: true })
    }
    setIsPendingUploadsModalOpen(false)
  }

  const handleClosePendingUploadsModal = () => {
    setIsPendingUploadsModalOpen(false)
    setPendingFormValues(null)
  }

  const onSubmit = async (values, { fromConfirmation = false } = {}) => {
    try {
      // Check if there are temporary attachments that haven't been uploaded yet for new events
      // Or if there are pending uploads for existing events
      if (!fromConfirmation && hasPendingUploads) {
        setPendingFormValues(values)
        setIsPendingUploadsModalOpen(true)
        return
      }

      // If editing an event and changing hasSubEvents from true to false, show confirmation
      // Skip this check if we're already coming from the confirmation modal
      if (
        !fromConfirmation &&
        eventId &&
        event?.hasSubEvents === true &&
        values.hasSubEvents === false
      ) {
        setPendingFormValues(values)
        setIsSubEventsWarningModalOpen(true)
        return
      }

      // If editing an event and changing hasSubEvents from false to true, show confirmation
      // Skip this check if we're already coming from the confirmation modal
      if (
        !fromConfirmation &&
        eventId &&
        event?.hasSubEvents === false &&
        values.hasSubEvents === true &&
        conference?.enableAcademics // Only show warning if academics is enabled (talks/posters)
      ) {
        setPendingFormValues(values)
        setIsAddSubEventsWarningModalOpen(true)
        return
      }

      // If editing an event and changing the venue ID or dates, show a combined confirmation
      if (
        !fromConfirmation &&
        eventId &&
        (event?.venueId !== values.venueId ||
          moment(event?.startDate).valueOf() !==
            moment(values.startDate).seconds(0).milliseconds(0).utc().valueOf() ||
          moment(event?.endDate).valueOf() !==
            moment(values.endDate).seconds(0).milliseconds(0).utc().valueOf())
      ) {
        // Determine what changed
        const venueChanged = event?.venueId !== values.venueId
        const timeChanged =
          moment(event?.startDate).valueOf() !==
            moment(values.startDate).seconds(0).milliseconds(0).utc().valueOf() ||
          moment(event?.endDate).valueOf() !==
            moment(values.endDate).seconds(0).milliseconds(0).utc().valueOf()

        setPendingFormValues(values)
        setVenueTimeChangeDetails({
          venue: venueChanged,
          time: timeChanged,
          hasSubEvents: values.hasSubEvents
        })
        setIsVenueTimeUpdateModalOpen(true)
        return
      }

      const moderators = removeUndefinedItemsFromArrayOfString(values.moderators) || []
      const speakers = removeUndefinedItemsFromArrayOfString(values.speakers) || []

      setLoading(true)
      const payload = {
        title: values.title.trim(),
        venueId: values.venueId.trim(),
        startDate: moment(values.startDate).seconds(0).milliseconds(0).utc().valueOf(),
        endDate: moment(values.endDate).seconds(0).milliseconds(0).utc().valueOf(),
        hasSubEvents: values.hasSubEvents,
        moderators: moderators,
        speakers: speakers,
        sponsors: removeUndefinedItemsFromArrayOfString(values.sponsors) ?? [],
        tags: removeUndefinedItemsFromArrayOfString(values.tags) ?? [],
        cardStyle: values.cardStyle.trim(),
        keynotes: values.keynotes.trim(),
        havePolls: values.havePolls === 'yes',
        pollIds: values.havePolls === 'yes' ? values.pollIds : [],
        // Legacy mirror for the mobile app's event-detail screen, which still builds its poll
        // join link from `event.pollId` and can't be redeployed on short notice. Which poll
        // ends up here doesn't matter — PoolForm.js resolves a bare pollId back to its owning
        // event and then discovers that event's *entire* pollIds set from there, so any valid
        // one is enough to get the attendee into the room. Remove once the mobile app sends
        // `eventId` directly instead (see docs/multi-poll-assignment.md, same as TalkForm.jsx).
        pollId:
          values.havePolls === 'yes' && values.pollIds.length
            ? values.pollIds[values.pollIds.length - 1]
            : null,
        excludeFromAttendance: values.excludeFromAttendance ?? false
      }

      const previousPollIds = event?.pollIds ?? (event?.pollId ? [event.pollId] : [])
      const addedPollIds = payload.pollIds.filter((id) => !previousPollIds.includes(id))
      const removedPollIds = previousPollIds.filter((id) => !payload.pollIds.includes(id))

      for (const id of addedPollIds) {
        const isAlreadyUsed = await alreadyUsedPoll(id)
        if (isAlreadyUsed) {
          toast.warning(AssociatedPollMsg)
          setLoading(false)
          return
        }
      }

      let newEventId = ''
      if (eventId) {
        await dispatch(updateEventById(eventId, payload))

        // Check if venue and/or time has changed and update all sub-events (sessions) accordingly
        if (event?.hasSubEvents && payload.hasSubEvents) {
          const changes = {}
          if (event?.venueId !== payload.venueId) {
            changes.venueId = payload?.venueId
          }
          // Process date changes if needed
          if (event?.startDate !== payload.startDate || event?.endDate !== payload.endDate) {
            changes.startDate = payload?.startDate
            changes.endDate = payload?.endDate
          }
          if (Object.values(changes).length) {
            await updateSubEvents(eventId, changes)
          }
        }

        // Check if venue and/or time has changed and update all talks accordingly
        if (!event?.hasSubEvents && !payload.hasSubEvents) {
          const changes = {}
          if (event?.venueId !== payload.venueId) {
            changes.venueId = payload?.venueId
          }
          // Process date changes if needed
          if (event?.startDate !== payload.startDate || event?.endDate !== payload.endDate) {
            changes.startDate = payload?.startDate
            changes.endDate = payload?.endDate
          }
          if (Object.values(changes).length) {
            await updateEventTalks(eventId, changes)
          }
        }

        localStorage.setItem('eventStartDate', payload.endDate)
        localStorage.setItem(
          'eventEndDate',
          payload.endDate + (payload.endDate - payload.startDate)
        )
        goBack()
      } else {
        newEventId = await dispatch(
          addEvent({
            ...payload,
            createdAt: moment().utc().valueOf()
          })
        )
        localStorage.setItem('eventStartDate', payload.endDate)
        localStorage.setItem(
          'eventEndDate',
          payload.endDate + (payload.endDate - payload.startDate)
        )

        // Upload and save temporary attachments to the new event
        if (temporaryAttachments.length > 0 && newEventId) {
          try {
            setLoadingAttachments(true)
            const attachmentsToAdd = []

            // Upload each file to Firebase Storage
            for (const attachment of temporaryAttachments) {
              try {
                // Upload to Firebase Storage
                const fileRef = storageRef.child(attachment.path)
                await fileRef.put(attachment.file)
                const downloadUrl = await fileRef.getDownloadURL()

                // Create attachment data without the file object
                const attachmentData = {
                  fileName: attachment.fileName,
                  fileType: attachment.fileType,
                  fileSize: attachment.fileSize,
                  storageFileName: attachment.storageFileName,
                  downloadUrl,
                  uploadedAt: attachment.uploadedAt,
                  path: attachment.path
                }
                attachmentsToAdd.push(attachmentData)
              } catch (error) {
                console.error(`Error uploading file ${attachment.fileName}:`, error)
                toast.error(`Could not upload ${attachment.fileName}.`)
              }
            }

            // Add all attachments to Firestore
            if (attachmentsToAdd.length > 0) {
              await addEventAttachments(newEventId, attachmentsToAdd)
              toast.success(`${attachmentsToAdd.length} attachment(s) uploaded.`)
            }
          } catch (error) {
            console.error('Error saving attachments to new event:', error)
            toast.error('Some attachments could not be uploaded.')
          } finally {
            setLoadingAttachments(false)
            setTemporaryAttachments([])
          }
        }
      }
      // detach polls that were removed, and attach newly assigned polls to this event
      await Promise.all(
        removedPollIds.map((id) =>
          pollAttachOrDetach(id, {
            eventId: null,
            sessionId: null,
            talkId: null,
            alreadyUsed: false
          })
        )
      )
      await Promise.all(
        addedPollIds.map((id) =>
          pollAttachOrDetach(id, {
            eventId: eventId ? eventId : newEventId,
            sessionId: '',
            talkId: '',
            alreadyUsed: true
          })
        )
      )

      if (!eventId && newEventId) {
        if (values.hasSubEvents) {
          history.replace(`/admin/schedule/events/${newEventId}/sub-events`)
        } else {
          goBack()
        }
      }
      toast.success(`Event ${eventId ? 'updated' : 'created'}.`)
      setLoading(false)
    } catch (err) {
      toast.error(err.message)
      setLoading(false)
    }
  }

  useEffect(() => {
    const fetchAttachments = async () => {
      setLoadingAttachments(true)
      try {
        const data = await getEventAttachments(eventId)
        setAttachments(data)
      } catch (error) {
        console.error('Error fetching attachments:', error)
      } finally {
        setLoadingAttachments(false)
      }
    }

    if (eventId) {
      fetchAttachments()
    }
  }, [eventId])

  const handleAttachmentAdded = async (attachments) => {
    try {
      if (eventId) {
        await addEventAttachments(eventId, attachments)
      }
      return true
    } catch (error) {
      console.error('Error adding attachment:', error)
      toast.error('Could not add attachment. Try again.')
      return false
    }
  }

  const handleAttachmentDeleted = async (attachment) => {
    try {
      if (eventId) {
        await deleteEventAttachment(eventId, attachment.id)
      } else {
        // Remove from temporary state for new events
        setAttachments(attachments.filter((a) => a.fileName !== attachment.fileName))
      }
      return true
    } catch (error) {
      console.error('Error deleting attachment:', error)
      toast.error('Could not delete attachment. Try again.')
      return false
    }
  }

  const handleTemporaryAttachments = (attachmentsData) => {
    setTemporaryAttachments(attachmentsData)
  }

  if (isLoading || inProgress) {
    return (
      <Box style={{ marginTop: '2rem' }}>
        <DataLoading />
      </Box>
    )
  }

  return (
    <CustomBox>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={eventFormSchema}
        onSubmit={onSubmit}>
        {({ values, setFieldValue, touched, setFieldTouched, errors, submitForm, isValid }) => {
          const overlappingIds = (values.moderators || []).filter((id) =>
            (values.speakers || []).includes(id)
          )
          const overlappingNames = overlappingIds
            .map((id) => {
              const person = [...confModerators, ...confSpeakers].find((p) => p.id === id)
              return person?.fullName || id
            })
            .join(', ')
          const rolesOverlapWarning = overlappingNames
            ? `${overlappingNames} ${
                overlappingIds.length > 1 ? 'are' : 'is'
              } added as both a moderator and a speaker.`
            : ''

          return (
            <Form>
              <ViewHeader title={eventId ? 'Edit Event' : 'Create Event'}>
                <Box style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <Button variant="outlined" onClick={goBack}>
                    Back
                  </Button>
                  {event?.id ? (
                    <>
                      {event?.hasSubEvents ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            history.push(`/admin/schedule/events/${event?.id}/sub-events`)
                          }>
                          View Sub Events
                        </Button>
                      ) : (
                        <>
                          {conference?.enableAcademics && (
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                history.push(`/admin/schedule/events/${event?.id}/talks`)
                              }>
                              View Talks/Posters
                            </Button>
                          )}
                        </>
                      )}
                    </>
                  ) : null}
                  <ProgressButton
                    type="submit"
                    label="Save"
                    size="small"
                    inProgress={inProgress || loading || loadingAttachments}
                    disabled={inProgress || loading || loadingAttachments}
                  />
                </Box>
              </ViewHeader>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={8}>
                  <CustomTextField label="Event Title" name="title" type="text" />
                </Grid>
                <Grid item xs={12} lg={4}>
                  <TextField
                    select
                    fullWidth
                    label="Building"
                    variant="outlined"
                    error={Boolean(touched.venueId && errors.venueId)}
                    value={values.venueId}
                    onChange={(event) =>
                      event.target.value && setFieldValue('venueId', event.target.value)
                    }
                    helperText={touched.venueId && errors.venueId ? errors.venueId : null}>
                    <MenuItem
                      className={classes.stickyMenuItem}
                      onClick={() => setOpenVenueModal(true)}>
                      <Typography className={classes.buttonItem}>
                        <Add />
                        Create building
                      </Typography>
                    </MenuItem>
                    <Divider />
                    {confBuildings?.map((building) => (
                      <MenuItem value={building?.id} key={building?.id}>
                        <Typography>
                          {building?.buildingText?.length > 50
                            ? `${building?.buildingText.substring(0, 50)}...`
                            : building?.buildingText}
                        </Typography>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={7} style={{ display: 'flex', gap: 10 }}>
                  <CustomDateTimePicker
                    mode="datetime"
                    value={values.startDate}
                    label="Start Date & Time"
                    name="startDate"
                    is24hrFormat={conference?.is24hrFormat || false}
                    minDateTime={
                      conference && moment(conference?.startDate).tz(conference?.timezone)
                    }
                    maxDateTime={conference && moment(conference?.endDate).tz(conference?.timezone)}
                    onChange={(value) => {
                      setFieldValue('startDate', value)
                      if (!eventId) {
                        setFieldValue('endDate', value)
                      }
                    }}
                    error={!!(touched.startDate && errors.startDate)}
                    helperText={touched.startDate && errors.startDate ? errors.startDate : ''}
                    onBlur={() => setFieldTouched('startDate', true)}
                  />

                  <CustomDateTimePicker
                    mode="datetime"
                    value={values.endDate}
                    label="End Date & Time"
                    name="endDate"
                    is24hrFormat={conference?.is24hrFormat || false}
                    minDateTime={
                      conference && moment(conference?.startDate).tz(conference?.timezone)
                    }
                    maxDateTime={conference && moment(conference?.endDate).tz(conference?.timezone)}
                    onChange={(value) => setFieldValue('endDate', value)}
                    error={!!(touched.endDate && errors.endDate)}
                    helperText={touched.endDate && errors.endDate ? errors.endDate : ''}
                    onBlur={() => setFieldTouched('endDate', true)}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormControl component="fieldset">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.hasSubEvents}
                          onChange={(e) => {
                            // If editing and unchecking the box, we'll handle this in onSubmit
                            // to show the confirmation modal only on save
                            setFieldValue('hasSubEvents', e.target.checked)
                          }}
                          color="primary"
                        />
                      }
                      label="Has sub events?"
                    />
                    <FormHelperText>Check this if the event can have sub-events</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl component="fieldset">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.excludeFromAttendance}
                          onChange={(e) => setFieldValue('excludeFromAttendance', e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Exclude from Attendance"
                    />
                    <FormHelperText>
                      {values.excludeFromAttendance
                        ? 'Attendance cannot be marked for this event.'
                        : 'Check this to hide this event from the attendance selection list'}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <MultiAutocomplete
                    label="Moderators"
                    options={confModerators || []}
                    displayField="fullName"
                    value={values.moderators}
                    error={errors.moderators}
                    warningText={rolesOverlapWarning}
                    onChange={(value) => setFieldValue('moderators', value)}
                    createNewOption={true}
                    createNewLabel="Create Moderator"
                    onCreateNew={() =>
                      setSpeakerModalInfo({
                        open: true,
                        role: SpeakerRoles.MODERATOR
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <MultiAutocomplete
                    label="Speakers"
                    options={confSpeakers || []}
                    displayField="fullName"
                    value={values.speakers}
                    error={errors.speakers}
                    warningText={rolesOverlapWarning}
                    onChange={(value) => setFieldValue('speakers', value)}
                    createNewOption={true}
                    createNewLabel="Create Speaker"
                    onCreateNew={() =>
                      setSpeakerModalInfo({
                        open: true,
                        role: SpeakerRoles.PRESENTER
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <MultiAutocomplete
                    label="Sponsors"
                    options={confSponsors || []}
                    displayField="organization"
                    value={values.sponsors}
                    error={errors.sponsors}
                    onChange={(value) => setFieldValue('sponsors', value)}
                    createNewOption={true}
                    createNewLabel="Create sponsor"
                    onCreateNew={() => setOpenSponsorModal(true)}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={[
                      ...(conference?.tags || []),
                      { name: 'Create new tag', isOption: false }
                    ]}
                    value={values.tags
                      .map((itemId) => conference?.tags?.find((item) => item['id'] === itemId))
                      .filter(Boolean)}
                    error={errors.tags}
                    onChange={(_e, value) => {
                      if (
                        Array.isArray(value) &&
                        value.length &&
                        value[value.length - 1].isOption === false
                      ) {
                        setTagModalOpen(true)
                        return
                      }
                      setFieldValue(
                        'tags',
                        value?.map((item) => item['id'])
                      )
                    }}
                    getOptionLabel={(option) => option?.name}
                    renderOption={(option) => {
                      return option.isOption === false ? (
                        <li className={classes.nonSelectedMenu}>
                          <Typography className={classes.buttonItem}>
                            <Add />
                            <Typography>{option.name}</Typography>
                          </Typography>
                        </li>
                      ) : (
                        <Box
                          component="li"
                          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Chip
                            label={option.name}
                            size="small"
                            style={{
                              backgroundColor: option.color || '#f1f1f1',
                              color: getContrastColor(option.color) || '#333',
                              borderRadius: '10px',
                              fontSize: '14px',
                              fontWeight: '500',
                              padding: '2px 4px',
                              height: '24px'
                            }}
                          />
                        </Box>
                      )
                    }}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          key={option.id}
                          label={option.name}
                          size="small"
                          style={{
                            backgroundColor: option.color || '#f1f1f1',
                            color: getContrastColor(option.color) || '#333',
                            marginRight: '4px',
                            fontSize: '14px',
                            borderRadius: '10px',
                            fontWeight: '500',
                            padding: '2px 4px',
                            height: '24px'
                          }}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={touched.tags && errors.tags}
                        variant="outlined"
                        label="Tags"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    select
                    fullWidth
                    label="Card Color"
                    variant="outlined"
                    error={Boolean(touched.cardStyle && errors.cardStyle)}
                    value={values.cardStyle}
                    onChange={(event) =>
                      event.target.value && setFieldValue('cardStyle', event.target.value)
                    }
                    helperText={touched.cardStyle && errors.cardStyle ? errors.cardStyle : null}>
                    <MenuItem
                      className={classes.stickyMenuItem}
                      onClick={() => setOpenCardColorModal(true)}>
                      <Typography className={classes.buttonItem}>
                        <Add />
                        Create card color
                      </Typography>
                    </MenuItem>
                    <Divider />
                    {confCardColors?.map((cardColor) => (
                      <MenuItem value={cardColor.id} key={cardColor.id}>
                        <Box className={classes.menuItem}>
                          <Box
                            sx={{
                              width: '18px',
                              height: '18px',
                              borderRadius: '4px',
                              backgroundColor: cardColor.bgColor ?? ''
                            }}></Box>
                          <Typography>{cardColor.type}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                    <label className={classes.label}>Keynotes</label>
                    <TipTapEditor
                      hasPlaceholders={false}
                      value={values.keynotes}
                      onChange={(value) => setFieldValue('keynotes', value)}
                      placeholder="Write keynotes here..."
                    />
                    <ErrorMessage message={touched?.keynotes && errors?.keynotes} />
                  </Box>
                </Grid>

                {/* Document Upload Section */}
                <Grid item xs={12}>
                  <DocumentUpload
                    title="Event Documents"
                    subTitle="Attach documents related to this event. Allowed formats: PDF, DOCX, XLSX, PPTX, TXT (Max size: 10MB)"
                    attachmentType="events"
                    entityId={eventId || null}
                    conferenceId={user?.conferenceId}
                    attachments={attachments}
                    onAttachmentAdded={handleAttachmentAdded}
                    onAttachmentDeleted={handleAttachmentDeleted}
                    onTemporaryAttachments={handleTemporaryAttachments}
                    onPendingUploadsChange={setHasPendingUploads}
                  />
                </Grid>

                {conference?.havePolls && (
                  <>
                    <Grid item xs={12}>
                      <Box className={classes.radioGroup}>
                        <Typography className={classes.radioLabel}>
                          Do you want to associate a poll with this Event?
                        </Typography>
                        <RadioGroup
                          row
                          value={values.havePolls}
                          onChange={(e) => {
                            // Don't eagerly clear pollIds here: PollAssignment only renders
                            // while havePolls is 'yes', so toggling to 'no' unmounts it and
                            // toggling back remounts it fresh — clearing pollIds first would
                            // make it think this entity never had any polls, disabling every
                            // still-genuinely-assigned poll as "assigned elsewhere" before the
                            // admin even saves. onSubmit already coerces pollIds to [] when
                            // havePolls is 'no', so nothing here needs to force it early.
                            setFieldValue('havePolls', e.target.value)
                          }}>
                          <FormControlLabel
                            control={<Radio size="small" />}
                            label={<Typography variant="body2">Yes</Typography>}
                            value="yes"
                          />
                          <FormControlLabel
                            control={<Radio size="small" />}
                            label={<Typography variant="body2">No</Typography>}
                            value="no"
                          />
                        </RadioGroup>
                      </Box>
                    </Grid>
                    {values.havePolls === 'yes' && (
                      <Grid item xs={12}>
                        <PollAssignment
                          conferenceId={user?.conferenceId}
                          speakerIds={values.speakers}
                          confSpeakers={confSpeakers}
                          value={values.pollIds}
                          persistedPollIds={event?.pollIds ?? (event?.pollId ? [event.pollId] : [])}
                          onChange={(pollIds) => setFieldValue('pollIds', pollIds)}
                          onSpeakerAdded={(speakerId) =>
                            setFieldValue('speakers', [...values.speakers, speakerId])
                          }
                          error={touched.pollIds && errors.pollIds}
                        />
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
              <Grid container spacing={2} className={classes.actionButtons}>
                <Grid item>
                  <Button size="large" onClick={goBack} disabled={inProgress || loading}>
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <ProgressButton
                    type="submit"
                    label="Save"
                    inProgress={inProgress || loading || loadingAttachments}
                    disabled={inProgress || loading || loadingAttachments}
                  />
                </Grid>
              </Grid>
              <ConfirmModal
                dialogTitle="Warning"
                dialogText={getWarningTextBasedOnEventTypesChange(
                  event?.eventType,
                  values.eventType
                )}
                dialogText2="Do you still want to continue?"
                open={isWarningModalOpen}
                closeModal={handleCloseWarningModal}
                handleConfirm={async () => {
                  if (isValid) {
                    await submitForm()
                  }
                }}
                inProgress={loading || inProgress}
              />
              <ConfirmModal
                dialogTitle="Warning"
                dialogText="Disabling 'Has sub events' will delete all sub-events associated with this event."
                dialogText2="This action cannot be undone. Do you want to continue?"
                open={isSubEventsWarningModalOpen}
                closeModal={handleCloseSubEventsWarningModal}
                handleConfirm={handleSubEventsWarningConfirm}
                inProgress={loading || inProgress}
              />
              <ConfirmModal
                dialogTitle="Warning"
                dialogText="Enabling 'Has sub events' will delete all talks/posters associated with this event."
                dialogText2="This action cannot be undone. Do you want to continue?"
                open={isAddSubEventsWarningModalOpen}
                closeModal={() => {
                  setIsAddSubEventsWarningModalOpen(false)
                  setPendingFormValues(null)
                }}
                handleConfirm={async () => {
                  if (pendingFormValues) {
                    // Delete all talks/posters associated with the event
                    if (eventId) {
                      setLoading(true)
                      try {
                        await deleteAllTalksOfEvent(eventId)
                        // Continue with form submission
                        await onSubmit(pendingFormValues, { fromConfirmation: true })
                      } catch (error) {
                        console.error('Error updating event after talks/posters deletion:', error)
                        toast.error('Could not update event after deleting talks/posters.')
                      } finally {
                        setLoading(false)
                      }
                    }
                    setIsAddSubEventsWarningModalOpen(false)
                  }
                }}
                inProgress={loading || inProgress}
              />
              <ConfirmModal
                dialogTitle="Update Building/Time Warning"
                dialogText={
                  venueTimeChangeDetails.hasSubEvents
                    ? venueTimeChangeDetails.venue && venueTimeChangeDetails.time
                      ? 'Changing the venue and date/time will update both for those sub-events that inherit them from this event, and will also update venue/time in posters and talks associated with those sub-events.'
                      : venueTimeChangeDetails.venue
                      ? 'Changing the venue will update the venue for those sub-events that inherit the venue from this event, and will also update the venue in posters and talks associated with those sub-events.'
                      : 'Changing the date/time will update start and end date/time for those sub-events that inherit time from this event, and will also update the time in posters and talks associated with those sub-events.'
                    : venueTimeChangeDetails.venue && venueTimeChangeDetails.time
                    ? 'Changing the venue and date/time will update both in talks that inherit them from this event.'
                    : venueTimeChangeDetails.venue
                    ? 'Changing the venue will update it in talks that inherit the venue from this event.'
                    : 'Changing the date/time will update the start and end date/time in talks that inherit time from this event.'
                }
                dialogText2="Do you want to continue?"
                open={isVenueTimeUpdateModalOpen}
                closeModal={handleCloseVenueTimeUpdateModal}
                handleConfirm={handleVenueTimeUpdateConfirm}
                inProgress={loading || inProgress}
              />
              <ConfirmModal
                dialogTitle="Pending File Uploads"
                dialogText="You have selected files that haven’t been uploaded. If you save now without clicking 'Upload All,' these files will not be uploaded. Do you want to continue?"
                open={isPendingUploadsModalOpen}
                closeModal={handleClosePendingUploadsModal}
                handleConfirm={handlePendingUploadsConfirm}
                inProgress={loading || inProgress}
              />
              <CustomPopup
                title="Create building"
                maxWidth="lg"
                open={openVenueModal}
                onClose={() => setOpenVenueModal(false)}>
                <BuildingForm
                  displayContext="modal"
                  onCloseModal={() => setOpenVenueModal(false)}
                  onSuccess={async (venueId) => {
                    setOpenVenueModal(false)
                    await fetchBuildings()
                    setFieldValue('venueId', venueId)
                  }}
                />
              </CustomPopup>
              <CustomPopup
                title="Create card color"
                maxWidth="lg"
                open={openCardColorModal}
                onClose={() => setOpenCardColorModal(false)}>
                <EventCardForm
                  displayContext="modal"
                  onCloseModal={() => setOpenCardColorModal(false)}
                  onSuccess={async (cardColorId) => {
                    await fetchCardColors()
                    setOpenCardColorModal(false)
                    setFieldValue('cardStyle', cardColorId)
                  }}
                />
              </CustomPopup>

              <CustomPopup
                title="Create Tag"
                maxWidth="md"
                open={tagModalOpen}
                onClose={() => setTagModalOpen(false)}>
                <TagForm
                  onCancel={() => setTagModalOpen(false)}
                  conference={conference}
                  onSuccess={(tagId) => {
                    setTagModalOpen(false)
                    setFieldValue('tags', [...values.tags, tagId])
                  }}
                />
              </CustomPopup>
              <CustomPopup
                title={`Create ${
                  speakerModalInfo?.role === SpeakerRoles.PRESENTER ? 'Speaker' : 'Moderator'
                }`}
                maxWidth="lg"
                open={speakerModalInfo?.open || false}
                onClose={() => setSpeakerModalInfo(null)}>
                <SpeakerForm
                  displayContext="modal"
                  preDefinedRole={speakerModalInfo?.role}
                  onCloseModal={() => setSpeakerModalInfo(null)}
                  onSuccess={async (id) => {
                    setSpeakerModalInfo(null)
                    await fetchModeratorsAndPresenters()
                    if (speakerModalInfo?.role === SpeakerRoles.PRESENTER) {
                      setFieldValue('speakers', [...values.speakers, id])
                    } else {
                      setFieldValue('moderators', [...values.moderators, id])
                    }
                  }}
                />
              </CustomPopup>

              <CustomPopup
                title="Create sponsor"
                maxWidth="lg"
                open={openSponsorModal}
                onClose={() => setOpenSponsorModal(false)}>
                <OrganizationForm
                  displayContext="modal"
                  onCloseModal={() => setOpenSponsorModal(false)}
                  onSuccess={async (sponsorId) => {
                    await fetchSponsors()
                    setOpenSponsorModal(false)
                    setFieldValue(
                      'sponsors',
                      values?.sponsors?.length > 0 ? [...values.sponsors, sponsorId] : [sponsorId]
                    )
                  }}
                />
              </CustomPopup>
            </Form>
          )
        }}
      </Formik>
    </CustomBox>
  )
}
export default EventForm

const useStyles = makeStyles({
  label: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    color: '#606060'
  },
  chipLabel: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    fontWeight: 'bold'
  },
  selectSpeakerMenu: {
    '& .MuiOutlinedInput-root': {
      '& .MuiSelect-outlined.MuiSelect-outlined': {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }
    }
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  chip: {
    background: '#c62828',
    color: '#FFFFFF'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  },
  actionButtons: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'end'
  },
  radioGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  radioLabel: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#2f2f2f'
  },
  nonSelectedMenu: {
    backgroundColor: 'transparent !important'
  },
  buttonItem: {
    color: colors.indigo,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem',
    baclkgroundColor: 'transparent'
  },
  stickyMenuItem: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: '#fff'
  }
})
